import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import SEO from "@/components/SEO";

import Home from "@/pages/Home";
import ServicesIndex from "@/pages/Services";
import AstrologyService from "@/pages/services/AstrologyService";
import NumerologyService from "@/pages/services/NumerologyService";
import TarotService from "@/pages/services/TarotService";
import VastuService from "@/pages/services/VastuService";
import YMTService from "@/pages/services/YantraMantraTantraService";
import Astrologers from "@/pages/Astrologers";
import Kundali from "@/pages/Kundali";
import Marketplace from "@/pages/Marketplace";
import Live from "@/pages/Live";
import Blogs from "@/pages/Blogs";
import Login from "@/pages/Login";
import OTPLogin from "@/pages/OTPLogin";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ProviderDashboard from "@/pages/ProviderDashboard";
import Admin from "@/pages/Admin";
import Membership from "@/pages/Membership";
import { CoursesList, CourseDetail } from "@/pages/LMS";
import VendorDashboard from "@/pages/VendorDashboard";
import LiveCall from "@/pages/LiveCall";
import { ChangePassword, ForgotPassword } from "@/pages/PasswordPages";

function DashboardRouter() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-12 text-center text-[#A0A4AB]">Loading…</div>;
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "astrologer" || user.role === "pandit") return <Navigate to="/provider" replace />;
  if (user.role === "vendor") return <Navigate to="/vendor" replace />;
  return <Dashboard />;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#050507] text-[#EAE6DF]">
        <SettingsProvider>
          <SEO />
          <AuthProvider>
          <BrowserRouter>
            <Navbar />
            <div className="pb-16 lg:pb-0">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<ServicesIndex />} />
                <Route path="/services/astrology" element={<AstrologyService />} />
                <Route path="/services/numerology" element={<NumerologyService />} />
                <Route path="/services/tarot" element={<TarotService />} />
                <Route path="/services/vastu" element={<VastuService />} />
                <Route path="/services/yantra-mantra-tantra" element={<YMTService />} />
                <Route path="/astrologers" element={<Astrologers />} />
                <Route path="/kundali" element={<Kundali />} />
                <Route path="/shop" element={<Marketplace />} />
                <Route path="/live" element={<Live />} />
                <Route path="/live-call/:room" element={<LiveCall />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/learn" element={<CoursesList />} />
                <Route path="/learn/:id" element={<CourseDetail />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/login" element={<Login />} />
                <Route path="/otp-login" element={<OTPLogin />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<DashboardRouter />} />
                <Route path="/provider" element={<ProviderDashboard />} />
                <Route path="/vendor" element={<VendorDashboard />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
              </Routes>
            </div>
            <Footer />
            <ChatWidget />
            <WhatsAppFloat />
            <MobileNav />
            <Toaster
              theme="dark"
              position="top-right"
              toastOptions={{
                style: {
                  background: "#0A0C10",
                  border: "1px solid rgba(212,175,55,0.3)",
                  color: "#EAE6DF",
                },
              }}
            />
          </BrowserRouter>
        </AuthProvider>
        </SettingsProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
